// extracted by css-extract-rspack-plugin
export default {"ViewButton":"fCHrO","active":"khSYX"};